import { BrowserRouter } from "react-router-dom";
import React from "react";
import { render } from "react-dom";
import { datadogRum } from "@datadog/browser-rum";
import { isInternetExplorer, isSafari } from "./utils/browserHelper";
import { parseDisplayUserName } from "./utils/userName";
import { isMobileView } from "./utils/isMobileView";
import { initDataDogRUM } from "./utils/datadogInit";
import App from "./App";

const initialState = window?._INITIAL_DATA_;

//Instantiate DataDog RUM
initDataDogRUM(datadogRum, initialState);

// Initialize ChurnZero
let isMobile = isMobileView();
const isSafariOrIE = isSafari() || isInternetExplorer();

if (initialState?.churnZeroAppKey && !isSafariOrIE && !isMobile) {
  const {
    churnZeroAppKey = "",
    productInfo: { interfaceId = "", productDomain = "" } = {},
    header: {
      userDetails: {
        affiliationId = "",
        puaId = "",
        displayName = "",
        fullDisplayName = "",
        email = "",
        specialty = "",
        role = ""
      } = {}
    } = {}
  } = initialState;

  let authHost = window.location.hostname;
  if (authHost === "localhost") {
    authHost = `www.${productDomain}`;
  }

  window.ChurnZero = window.ChurnZero || []; // Just in case the Churnzero failed to load
  window.ChurnZero.push(["setAppKey", churnZeroAppKey]);
  window.ChurnZero.push([
    "setContact",
    affiliationId,
    `${puaId || "anon"}_${interfaceId}`
  ]);
  window.ChurnZero.push(["setAttribute", "contact", "auth_host", authHost]);

  if (puaId) {
    const { firstName, lastName } = parseDisplayUserName(
      fullDisplayName || displayName
    );

    window.ChurnZero.push(["setAttribute", "contact", "First Name", firstName]);
    window.ChurnZero.push(["setAttribute", "contact", "Last Name", lastName]);
    window.ChurnZero.push(["setAttribute", "contact", "Email", email]);
    window.ChurnZero.push([
      "setAttribute",
      "contact",
      "Medicalspecialty",
      specialty
    ]);
    window.ChurnZero.push(["setAttribute", "contact", "Medicalrole", role]);
  }
}

/* eslint react/no-deprecated: 0 */
// overrides eslint react/no-deprecated rule since we're not on React 18 yet
render(
  <BrowserRouter>
    <App configData={initialState} />
  </BrowserRouter>,
  document.getElementById("root")
);

if (module.hot) {
  module.hot.accept();
}
